<template>
  <collection
    name="character"
    :loading="loading"
    :options="options"
    :data="getAllCharacters"
  >
    <template v-slot:item="slotProps">
      <character-preview v-bind="slotProps.record" />
    </template>
  </collection>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import searchConfig from '@/utilities/searchConfig';
import Collection from '@/components/Collection.vue';
import CharacterPreview from './characters/CharacterPreview.vue';

export default {
  name: 'ListCharacters',
  components: {
    Collection,
    CharacterPreview,
  },
  data() {
    return {
      loading: true,
      views: ['Grid', 'Reorder'],
      options: {
        search: {
          ...searchConfig,
          keys: ['name', 'bio', 'firstSeen'],
        },
      },
    };
  },
  computed: {
    ...mapGetters(['getAllCharacters']),
    view() {
      return this.$route.query.view || this.views[0];
    },
    sortedCharacters: {
      get() {
        return this.getAllCharacters;
      },
      set(value) {
        const records = value.map((record, index) => ({
          ...record,
          position: index,
        }));
        this.reorder(records);
      },
    },
  },
  methods: {
    ...mapActions(['fetch']),
    reorder(characters) {
      this.$store.dispatch('reorderCharacters', characters);
    },
    setView(view) {
      this.$router.push({ query: { view } });
    },
  },
  mounted() {
    this.fetch({ model: 'characters' }).finally(() => {
      this.loading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.characters {
  &__reorder {
    max-width: 520px;
    margin: 0 auto;
    div {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
